<template>
  <div>
    <div v-if="loading" class="text-slate-500 text-sm">Ładowanie adresów…</div>
    <div v-else>
      <div v-if="addresses.length > 0" class="space-y-3">
        <label for="mp-address" class="block text-sm font-medium text-slate-700">Wybierz domyślny adres</label>
        <select id="mp-address" v-model="selectedId" class="w-full border rounded-md p-2">
          <option :value="0">— Wybierz adres —</option>
          <option v-for="addr in addresses" :key="addr.id_address" :value="addr.id_address">
            {{ addr.label }}
          </option>
        </select>
        <div class="flex items-center gap-3">
          <button class="btn btn-primary" :disabled="saving || selectedId===0" @click="save">Zapisz</button>
          <span v-if="saved" class="text-green-600 text-sm">Zapisano</span>
        </div>
      </div>
      <div v-else class="text-slate-600">
        Brak adresów. <a :href="addAddressUrl" class="text-blue-600 underline">Dodaj adres</a> w panelu konta.
      </div>
    </div>
    <div class="mt-2 text-sm">
      <a :href="addAddressUrl" class="text-blue-600 underline">Dodaj nowy adres</a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { postJson, useApiConfig } from '../composables/useApi';

type Address = {
  id_address: number;
  alias: string;
  address1: string;
  postcode: string;
  city: string;
  country: string;
  label: string;
};

const cfg = useApiConfig();
const addresses = ref<Address[]>([]);
const selectedId = ref<number>(0);
const loading = ref<boolean>(true);
const saving = ref<boolean>(false);
const saved = ref<boolean>(false);
const addAddressUrl = (cfg.addAddressUrl || '/address') as string;

async function load() {
  loading.value = true;
  try {
    const res = await postJson<{ success: boolean; data: { addresses: Address[]; selected_id: number|null } }>(cfg.apiAddresses || '', {});
    if (res && res.success) {
      addresses.value = res.data.addresses || [];
      selectedId.value = (res.data.selected_id || 0) as number;
    }
  } catch (e) {
    // noop
  } finally {
    loading.value = false;
  }
}

async function save() {
  if (!selectedId.value || selectedId.value <= 0) return;
  saving.value = true;
  saved.value = false;
  try {
    await postJson(cfg.apiAddressSetDefault || '', { id_address: selectedId.value });
    saved.value = true;
    setTimeout(() => (saved.value = false), 2000);
  } catch (e) {
    // noop
  } finally {
    saving.value = false;
  }
}

onMounted(load);
</script>

<style scoped>
.btn {
  @apply py-2 px-3 rounded-md text-white;
}
.btn-primary {
  @apply bg-blue-600 hover:bg-blue-700 disabled:opacity-50;
}
</style>

